import { createFileRoute } from '@tanstack/react-router'

import { ChurnWinbackSearchSchema } from '@/pages/brevo/automations/churn-winback/churn-winback-search'

export const Route = createFileRoute('/_layout/brevo/automations/churn-winback')({
  validateSearch: ChurnWinbackSearchSchema,
})
